import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Language from "../language/language";
import { Badge } from "antd";
import classnames from "classnames";
import { $util } from "../../helper";

import "./stylesheets/navigation.scss";

@inject("languageStore", "navStore", "authStore", "commonStore")
@withRouter
@observer
export default class Navigation extends React.Component {
  state = {
    show: true,
  };
  componentDidMount() {}
  changeNavigation = (nav, entryName) => {
    this.props.commonStore.gTag("event", "navigationEntry", {
      pageName: $util.getPageName(),
      buttonName: entryName,
    });
    this.props.navStore.changeNavigation(nav);
    this.props.history.push(nav);
  };
  render() {
    return (
      <div className="navigation">
        <ul>
          <li
            className={classnames({
              actived:
                this.props.navStore.navigation === "/registration-center",
              cn: this.props.languageStore.lang === "zh", //中文文字字数相同，所以应该保持左右对齐，所以给一个类写左对齐；英文字数不同，保持居中对齐
            })}
            onClick={this.changeNavigation.bind(
              this,
              "/registration-center",
              "registrationCenter"
            )}
          >
            <Language resource="REGISTRATION_CENTER" />
          </li>
          <li
            className={classnames({
              actived: this.props.navStore.navigation === "/control-center",
              cn: this.props.languageStore.lang === "zh",
            })}
            onClick={this.changeNavigation.bind(
              this,
              "/control-center",
              "controlCenter"
            )}
          >
            <Language resource="CONTROL_CENTER" />
          </li>
          <li
            className={classnames({
              actived: this.props.navStore.navigation === "/message-center",
              cn: this.props.languageStore.lang === "zh",
            })}
            onClick={this.changeNavigation.bind(
              this,
              "/message-center",
              "messageCenter"
            )}
          >
            <Badge dot={this.props.authStore.hasUnReadMessage}>
              <Language className="message-center" resource="MESSAGE_CENTER" />
            </Badge>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.js